/** A surface with the shared border, radius and shadow (task 9.2). */
import type { HTMLAttributes, JSX } from 'react';

export function Card({ className = '', ...rest }: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={`rounded-xl border border-line bg-surface shadow-card ${className}`}
      {...rest}
    />
  );
}

export function CardBody({ className = '', ...rest }: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div className={`p-4 sm:p-5 ${className}`} {...rest} />;
}
